import React from 'react';
import { Card, CardBody, Container, Row, Col } from 'reactstrap';

const NewerToPlantPoweredEatingContent = () => (
  <>
    <h4>Newer to Plant-Powered Eating?</h4>
    <h5>Focus on Adding, Not Removing</h5>
    <p>
      The most effective strategy? Crowding out. Fill up on good foods first — the unhealthy stuff naturally falls away.
      Craving sweets after dinner? Grab berries first, wait a few minutes, and see what happens.
    </p>
    <h5>What to Expect</h5>
    <ul>
      <li>More energy and mental clarity</li>
      <li>Better blood sugar stability</li>
      <li>Possible temporary digestive changes (increased gas from more fiber — totally normal, and it passes!)</li>
      <li>Some cravings as your body adjusts away from sugar and processed foods</li>
    </ul>
  </>
);

const QuickKitchenSetupContent = () => (
  <>
    <h4>Quick Kitchen Setup</h4>
    <ul>
      <li>
        <strong>Cookware:</strong> Ditch old nonstick (Teflon). Go with stainless steel, ceramic-coated, or enamel cast
        iron. A pressure cooker is a game-changer for legumes.
      </li>
      <li>
        <strong>Organization:</strong> Keep go-to tools within reach. Store spices away from heat. Keep pots with their
        lids. An organized kitchen = less friction.
      </li>
      <li>
        <strong>Clear the clutter:</strong> Go through your fridge, freezer, and cupboards. Remove the items pulling you
        in the wrong direction and replace them with whole food alternatives.
      </li>
    </ul>
  </>
);

const AlreadyOnTheJourneyContent = () => (
  <>
    <h4>Already on Your Plant-Powered Journey?</h4>
    <ul>
      <li>
        <strong>Try something new:</strong> Use weekly guides to explore unfamiliar cuisines and ingredients.
      </li>
      <li>
        <strong>Optimize:</strong> Dial in your omega-3/omega-6 ratio, B12, vitamin D, and fiber diversity.
      </li>
      <li>
        <strong>Go deep:</strong> Your 8-week track features expert Action Hours with cutting-edge insights.
      </li>
      <li>
        <strong>Lead:</strong> Support newer members in the forum. Teaching deepens your own commitment.
      </li>
      <li>
        <strong>Audit your kitchen:</strong> Time to replace worn cookware? Upgrade a tool? Small changes reignite the
        spark.
      </li>
    </ul>
  </>
);

export const GettingStartedSuccessCard = () => (
  <Card className="getting-started-success">
    <CardBody>
      <h2 className="mb-4 mt-0">Set Yourself Up for Success</h2>
      <p>Choose what’s relevant to you and skip what you already know.</p>
      <NewerToPlantPoweredEatingContent />
      <QuickKitchenSetupContent />
      <AlreadyOnTheJourneyContent />
    </CardBody>
  </Card>
);

const GettingStartedSuccessSection = () => (
  <Container className="background-light-purple getting-started-success">
    <Row>
      <Col xs="12">
        <h2 className="mb-4">Set Yourself Up for Success</h2>
        <p>Choose what’s relevant to you and skip what you already know.</p>
        <Card>
          <CardBody>
            <div className="pb-4">
              <NewerToPlantPoweredEatingContent />
            </div>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <div className="pb-4">
              <QuickKitchenSetupContent />
            </div>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <div className="pb-4">
              <AlreadyOnTheJourneyContent />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>
);

export default GettingStartedSuccessSection;
